import { render, staticRenderFns } from "./NextButton.vue?vue&type=template&id=79e958fd&scoped=true"
import script from "./NextButton.vue?vue&type=script&lang=js"
export * from "./NextButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e958fd",
  null
  
)

export default component.exports